export const getStorefrontOrigin = (shopifyDomain: string) => {
  const domain = shopifyDomain.trim();
  const url = new URL(/^https?:/.test(domain) ? domain : `https://${domain}`);
  url.protocol = "https";

  return url.origin;
};

export const getStorefrontEndpoint = (shopifyDomain: string, apiVersion: string) => {
  return `${getStorefrontOrigin(shopifyDomain)}/api/${apiVersion.trim()}/graphql.json`;
};
